import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import Axios from 'axios'
import ElementUI from 'element-ui'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { i18n } from '@/i18n'
import '../public/style/element-ui-reset.scss'
import '../public/style/theme-index.css' // 自定义主题文件
import '@/assets/yyq-icon/iconfont.css'
import '@/assets/yyq-icon/iconfont'
import VueWechatTitle from 'vue-wechat-title' // 动态修改title
import common from './router/common'
// import dynamicRoutes from './router/routers'
import urls from './api/url'
import base from './functions/base'
import util from './functions/util'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import closeModalBtn from './components/loginPublic/closeModalBtn.vue'

Vue.config.productionTip = false
Axios.defaults.baseURL = urls.baseURL
Vue.use(ElementUI, { zhLocale })
Vue.use(VueWechatTitle)
Vue.component('closeModalBtn', closeModalBtn)

store.dispatch('getLoginSource').then() // 判断是否嵌套项目

// 设置Cookie
Vue.prototype.setCookie = function (name, value, day) {
  day = day >= 0 ? day : 365 // 默认365天后过期
  const time = new Date(Date.now() + day * 24 * 60 * 60 * 1000).toUTCString() // day天后过期
  // 区分了ip和域名
  let domain = +window.location.hostname.split('.').slice(-2).join('.') > -1 ? '' : window.location.hostname.split('.').slice(-2).join('.')
  document.cookie = (name + '=' + encodeURIComponent(value) + ';path=/;expires=' + time + ';domain=' + domain)
}
Axios.defaults.timeout = 0
// 添加请求拦截器
Axios.interceptors.request.use(config => {
  config.headers['lan-i18n-code'] = store.state.publicModules.language
  return config
}, error => {
// 对请求错误做些什么
  return Promise.reject(error)
})
// http response 拦截器
Axios.interceptors.response.use(response => {
  return response
}, error => {
  // return Promise.reject(error.response.data)
  return Promise.reject(error)
})
// 路由限制
Vue.use(common)
// const sessionPermission = JSON.parse(sessionStorage.getItem('pm_project_permission')) || []
// if (sessionPermission) {
//   const matchedRoutes = Vue.prototype.matchPermission(dynamicRoutes, sessionPermission) || []
//   router.options.routes = router.options.routes.concat(matchedRoutes)
//   router.$addRoutes(router.options.routes)
// }
const env = process.env.VUE_APP_SENTRY
console.log(env)
if (env === 'prod') {
  Sentry.init({
    Vue,
    dsn: 'https://ea9f61d8f5574d159dd282d28e6245fa@sentry.lan-bridge.cn/43',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [Axios.defaults.baseURL, /^\//]
      })
    ],
    tracesSampleRate: 1.0,
    environment: env,
    logErrors: true,
    beforeSend (event, hint) {
      const err = hint.originalException
      if (err && !err.message) {
        return null
      }
      return event
    }
  })
}
Vue.prototype.axios = Axios
Vue.prototype.Base = base
Vue.prototype.util = util
Vue.prototype.$urls = urls
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
